import React, { useState, useEffect } from "react";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import logo from "../assets/profile.jpg"
export default function UserProfile() {
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState([]);
    const [profile, setProfile] = useState({});
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    useEffect(() => {
        fetchAllData();
    }, []);

    const fetchAllData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStateData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "user/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setProfileData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (profileData) {
            setProfile({
                name: profileData.first_name || "",
                email: profileData.email_id || "",
                phone: profileData.mobile_number || "",
                city: profileData.city || "",
                state: profileData.state_name || "",
                address1: profileData.address_line1 || "",
                address2: profileData.address_line2 || "",
                landmark: profileData.landmark || "",
                pincode: profileData.pincode || "",
                state_id: profileData.state_id || "",
                district_id: profileData.district_id || "",
            });
        }
    }, [profileData]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSave = async () => {
        try {
            setLoading(true);
            const payload = {
                first_name: profile.name,
                email_id: profile.email,
                mobile_number: profile.phone,
                city: profile.city,
                address_line1: profile.address1,
                address_line2: profile.address2,
                landmark: profile.landmark,
                pincode: profile.pincode,
                district_id: profile.district_id ? Number(profile.district_id) : null,
                state_id: profile.state_id ? Number(profile.state_id) : null,
            };
            const url = webEndPoint + "user/" + localStorage.getItem("userID");
            const response = await makeRequest("put", url, payload);
            if (response) {
                toast.success("Profile updated successfully");
                setIsEditing(false);
                fetchAllData();
            }
        } catch (err) {
            console.error(err);
            toast.error("Update failed");
        } finally {
            setLoading(false);
        }
    };
    const handleStateChange = async (e) => {
        setLoading(true);
        const stateId = e.target.value;
        setProfile((prev) => ({
            ...prev,
            state_id: stateId,
            district_id: ""
        }));
        try {
            const url = webEndPoint + "districts/state/" + stateId;
            const res = await makeRequest("get", url);
            if (res) {
                setDistrictData(res.data);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setProfile((prev) => ({
            ...prev,
            district_id: districtId
        }));
    };
    return (
        <div className="profile-page">
            <Loader loading={loading} />
            <h2>My Profile</h2>
            <div className="profile-card">
                <div className="profile-avatar">
                    <img src={logo} alt="profile" />
                </div>
                <div className="profile-details">
                    {!isEditing ? (
                        <div className="profile-view">
                            <p><strong>Name:</strong> {profileData?.first_name}</p>
                            <p><strong>Email:</strong> {profileData?.email_id}</p>
                            <p><strong>Phone:</strong> {profileData?.mobile_number}</p>
                            <p><strong>City:</strong> {profileData?.city}</p>
                            <p><strong>District:</strong> {profileData?.district_name}</p>
                            <p><strong>State:</strong> {profileData?.state_name}</p>
                            <p><strong>Address Line 1:</strong> {profileData.address_line1}</p>
                            <p><strong>Address Line 2:</strong> {profileData.address_line2}</p>
                            <p><strong>Landmark:</strong> {profileData.landmark}</p>
                            <p><strong>Pincode:</strong> {profileData.pincode}</p>
                            <button className="edit-profile-btn" onClick={() => setIsEditing(true)}>Edit Profile</button>
                        </div>
                    ) : (
                        <div className="profile-form">
                            <input type="text" name="name" value={profile.name} onChange={handleChange} placeholder="Full Name" />
                            <input type="email" name="email" value={profile.email} onChange={handleChange} placeholder="Email" />
                            <input type="text" name="phone" value={profile.phone} onChange={handleChange} placeholder="Phone" />
                            <input type="text" name="city" value={profile.city} onChange={handleChange} placeholder="City" />
                            <select name="state_id" value={profile.state_id} onChange={handleStateChange}>
                                <option value="">Select State</option>
                                {stateData?.map((s) => (
                                    <option key={s.rfId} value={s.rfId}>{s.state_name}</option>
                                ))}
                            </select>
                            <select name="district_id" value={profile.district_id} disabled={!profile.state_id} onChange={handleDistrictChange} >
                                <option value="">Select District</option>
                                {districtData?.map((d) => (
                                    <option key={d.district_id} value={d.district_id}>{d.district_name}</option>
                                ))}
                            </select>
                            <input type="text" name="address1" value={profile.address1} onChange={handleChange} placeholder="Address Line 1" />
                            <input type="text" name="address2" value={profile.address2} onChange={handleChange} placeholder="Address Line 2" />
                            <input type="text" name="landmark" value={profile.landmark} onChange={handleChange} placeholder="Landmark" />
                            <input type="text" name="pincode" value={profile.pincode} onChange={handleChange} placeholder="Pincode" />
                            <div className="profile-actions">
                                <button className="save-btn" onClick={() => handleSave()}>Save</button>
                                <button className="cancel-btn" onClick={() => setIsEditing(false)}>Cancel</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}